import { UnsafeTFunction } from '../../i18next';

export const WEAK_PASSWORD_SNACK = {
  message: (t: UnsafeTFunction) =>
    t(
      'The password must contain at least\n• 12 characters\n• one number\n• one capital letter\n• one lower case letter\n• one symbol'
    ),
  options: {
    variant: 'error',
    style: { whiteSpace: 'pre-line' }
  } as const
};
